// extracted by mini-css-extract-plugin
export default {"isProcessing":"styles_isProcessing__fUMFc","buttonSpinner":"styles_buttonSpinner__Pyo+p"};